import { normalizeConfig } from './config_schema';
import { headerToKey, indexToLetter } from './keys';

/** Example columns used in live preview until the user pastes real headers. */
const PLACEHOLDER_HEADERS = ['ID', 'Name', 'Status'];

/**
 * Config safe for live Code.gs / HTML generation (never empty sheet.columns).
 * @param {import('./config_schema.js').PortalConfig} config
 * @returns {{ config: import('./config_schema.js').PortalConfig, isBoilerplateColumns: boolean }}
 */
export function configForLivePreview(config) {
  const c = normalizeConfig(structuredClone(config));
  const ref = c.sheet.defaultReference === 'letter' ? 'letter' : 'header';
  let isBoilerplateColumns = false;

  if (!c.sheet.columns?.length) {
    isBoilerplateColumns = true;
    c.sheet.columns = PLACEHOLDER_HEADERS.map((header, i) => ({
      header,
      key: headerToKey(header),
      reference: ref,
      letter: indexToLetter(i),
      number: i + 1
    }));
  }

  const lookupIdx =
    typeof c.sheet.lookup?.columnIndex === 'number' && c.sheet.lookup.columnIndex >= 0
      ? c.sheet.lookup.columnIndex
      : 0;

  const lookupCol = c.sheet.columns[lookupIdx] || c.sheet.columns[0];
  c.sheet.lookup = {
    ...c.sheet.lookup,
    reference: ref,
    header: lookupCol.header,
    letter: lookupCol.letter,
    number: lookupCol.number,
    columnIndex: lookupIdx
  };

  c.script.htmlFileName = 'Page';
  if (!String(c.script?.pageTitle || '').trim()) {
    c.script.pageTitle = 'My Portal';
  }
  if (!String(c.script?.webAppUrlPlaceholder || '').trim()) {
    c.script.webAppUrlPlaceholder = 'PASTE_DEPLOYMENT_URL_HERE';
  }

  return { config: c, isBoilerplateColumns };
}

/**
 * @param {boolean} isBoilerplateColumns
 * @param {'gs'|'html'} kind
 */
export function livePreviewBanner(isBoilerplateColumns, kind) {
  if (!isBoilerplateColumns) {
    return kind === 'gs'
      ? '// Live preview: updates as you edit sheet + portal settings.\n'
      : '<!-- Live preview: updates as you edit portal settings. -->\n';
  }
  return kind === 'gs'
    ? '// Boilerplate preview: paste row 1 headers above to replace example columns.\n'
    : '<!-- Boilerplate preview: paste row 1 headers to customize data fields. -->\n';
}
